import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../dto/data-model.js';
import { MapUtils } from '../../utility/map-utils.js';

/**
 * @deprecated Use {@link NTAKServiceLocation} instead.
 */
export class NTAKAccountSettings extends DataModel {
  public static readonly TYPE_ID: string = '808194c60a3a47499e98cd4a3968a9a5';

  private constructor(
    public readonly taxNumber: string,
    public readonly registrationNumber: string,
    public readonly certificate: string,
  ) {
    super();
  }

  get $removable(): boolean {
    return true;
  }

  get $typeId(): string {
    return NTAKAccountSettings.TYPE_ID;
  }

  static create(args: {
    taxNumber: string,
    registrationNumber: string,
    certificate: string,
  }): NTAKAccountSettings {
    return new NTAKAccountSettings(
        args.taxNumber,
        args.registrationNumber,
        args.certificate,
    );
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData,
  ): NTAKAccountSettings {
    return new NTAKAccountSettings(
        MapUtils.get<string>(map, 'taxNumber'),
        MapUtils.get<string>(map, 'registrationNumber'),
        MapUtils.get<string>(map, 'certificate'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      taxNumber: this.taxNumber,
      registrationNumber: this.registrationNumber,
      certificate: this.certificate,
    };
  }

  clone(): this {
    return new NTAKAccountSettings(
        this.taxNumber,
        this.registrationNumber,
        this.certificate,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.taxNumber === this.taxNumber &&
        other.registrationNumber === this.registrationNumber &&
        other.certificate === this.certificate;
  }
}

export class NTAKAccountSettingsBuilder extends DataModelBuilder<NTAKAccountSettings> {
  build(context: SerializationContext, map: SerializedData): NTAKAccountSettings {
    return NTAKAccountSettings.fromMap(context, map);
  }
}
